export default __webpack_public_path__ + "static/media/more-details.e350e507.svg";